export default "__VITE_ASSET__D_odJWX4__"